import React from 'react';
import styles from './EventFAQs.module.scss';
import { useIntl } from 'react-intl';
import type { FAQ } from './types';
import { FAQItem } from './components/FAQItem';
import { useComponentVisibilityWithTracking } from '@/src/listings/hooks/useComponentVisibility';
import { LISTING_HEAP_IDS } from '../_shared/constants';

export const FAQ_TRACKING_CONFIG = {
  heap: {
    eventName: LISTING_HEAP_IDS.FAQ_VIEW,
  },
  heapId: LISTING_HEAP_IDS.FAQS_DROPDOWN,
} as const;

interface EventFAQsProps {
  faqs: FAQ[];
}

export const EventFAQs: React.FC<EventFAQsProps> = ({ faqs }) => {
  const { formatMessage } = useIntl();

  const ref = useComponentVisibilityWithTracking(undefined, FAQ_TRACKING_CONFIG);

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <div ref={ref} data-testid="event-faqs" data-heap-id={FAQ_TRACKING_CONFIG.heapId}>
      <div className={styles.content}>
        <div className={styles.title}>{formatMessage({ id: 'Frequently asked questions' })}</div>
        {faqs.map((faq) => (
          <FAQItem key={`${faq.question}-${faq.answer}`} faq={faq} />
        ))}
      </div>
    </div>
  );
};
